/** Калькулятор стоимости готового сайта (логика как у Paradigma: -50% на пакет + сумма доп.услуг). */
export default function initReadySiteCalc() {
  const root = document.querySelector('[data-rs-calc]')
  if (!root) return

  const form = root.querySelector('[data-rs-calc-form]')
  const totalEl = root.querySelector('[data-rs-calc-total]')
  const oldEl = root.querySelector('[data-rs-calc-old]')
  if (!form || !totalEl || !oldEl) return

  const discountPct = Number(root.getAttribute('data-discount') || '50')

  const format = (n) => String(Math.round(n))

  const update = () => {
    const radio = form.querySelector('input[type="radio"][name="license"]:checked')
    const base = Number(radio?.getAttribute('data-price') || 0)
    let extras = 0
    form.querySelectorAll('input[type="checkbox"][name="services[]"]:checked').forEach((el) => {
      extras += Number(el.getAttribute('data-price') || 0)
    })

    const discountedBase = base - Math.round((base * discountPct) / 100)
    oldEl.textContent = format(base + extras)
    totalEl.textContent = format(discountedBase + extras)
  }

  form.addEventListener('change', update)
  update()

  const buyBtn = root.querySelector('[data-rs-calc-buy]')
  buyBtn?.addEventListener('click', () => {
    const total = totalEl.textContent
    const radio = form.querySelector('input[type="radio"][name="license"]:checked')
    const services = [...form.querySelectorAll('input[type="checkbox"][name="services[]"]:checked')].map((el) => el.value)
    const subject = encodeURIComponent(`Заказ готового сайта — ${total} ₽`)
    const body = encodeURIComponent(
      [
        `Пакет: ${radio?.value || ''}`,
        services.length ? `Доп. услуги:\n- ${services.join('\n- ')}` : 'Доп. услуги: нет',
        `Итого: ${total} ₽`,
      ].join('\n')
    )
    window.location.href = `mailto:info@randee.ru?subject=${subject}&body=${body}`
  })
}
